import { css } from '@emotion/react';
import { ButtonProps, buttons, ButtonTypes } from '~/components/Button';

interface SubmitButtonProps {
  submitting: boolean;
  submittedSuccess: boolean;
  preSubmitText: string;
  successSubmitText?: string;
  buttonType: ButtonTypes;
  autoWidth?: boolean;
}

const submitButtonStyle = css`
  min-width: 100px;
`;

const SubmitButton = (props: SubmitButtonProps & ButtonProps) => {
  const {
    submitting,
    submittedSuccess,
    preSubmitText,
    successSubmitText,
    buttonType,
    autoWidth,
    fullWidth,
    ...buttonProps
  } = props;
  const Button = buttons[buttonType];
  const text = submittedSuccess ? successSubmitText : preSubmitText;
  const css = !(autoWidth || fullWidth) ? submitButtonStyle : undefined;

  return (
    <Button isLoading={submitting} css={css} fullWidth={fullWidth} {...buttonProps}>
      {text}
    </Button>
  );
};

export default SubmitButton;
